import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    zIndex: 10,
    width: '100%',
    height: 'auto',
    padding: 15,
    display: 'flex',
    flexDirection: 'column',
    boxShadow: theme.shadows[3],
    scrollBehavior: 'smooth',
    backgroundColor: theme.palette.background.paper2,
  },
  scrollItems: {
    paddingTop: 6,
    paddingBottom: 6,
    width: '100%',
    display: 'flex',
    flexWrap: 'nowrap',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    overflowY: 'hidden',
    overflowX: 'auto',
    scrollBehavior: 'smooth',
    '&::-webkit-scrollbar': {
      width: theme.shape.scrollSize,
      height: theme.shape.scrollSize,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.scroll,
      borderRadius: theme.shape.scrollRadius,
    },
  },
}))

export default useStyles
